<template>
  <div :class="$attrs.class">
    <label
      v-if="label"
      class="form-label"
      :for="id">{{ label }}:</label>
    <select
      :id="id"
      ref="input"
      v-model="selected"
      v-bind="{ ...$attrs, class: null }"
      class="form-select"
      :class="{ error: error }">
      <slot />
    </select>
    <div v-if="error" class="form-error">
      {{ error }}
    </div>
  </div>
</template>

<script lang="js">
export default {
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default () {
                return `select-input-${self.crypto.randomUUID()}`
            },
        },
        error: String,
        label: String,
        modelValue: [String, Number, Boolean],
    },
    emits: ['update:modelValue'],
    data () {
        return {
            selected: this.modelValue,
        }
    },
    watch: {
        selected (selected) {
            this.$emit('update:modelValue', selected)
        },
        modelValue (modelValue) {
            this.selected = modelValue
        },
    },
    methods: {
        focus () {
            this.$refs.input.focus()
        },
        select () {
            this.$refs.input.select()
        },
    },
}
</script>
